export type ProfileProps = {
    DisplayName: string
    PlayerId: string
    PublisherId: string
    TitleId: string
}

export type LeaderboardProps = {
    DisplayName: string | null
    PlayFabId: string | null
    Position: number | null
    Profile: ProfileProps | null
    StatValue: number | null
}

export enum LEADERBOARDVIEW {
    MARKS = "RewardPool_Marks",
    VALOR = "RewardPool_Valor",
    MERIT = "RewardPool_Merit",
    DAILY = "RewardPool_Marks_Daily",
}

export enum LEADERBOARD {
    FETCHAROUNDPLAYER = "FETCHAROUNDPLAYER",
    FETCHBYNUMBER = "FETCHBYNUMBER",
}
